module.exports = __webpack_public_path__ + "static/media/video_consent_audio_ass.66f12cf2.mp3";